export const getButtonColor = (color, variant, property) => {
	if (variant === 'outlined') {
		if (property === 'bg') {
			return 'transparent';
		} else {
			return color.startsWith('#') ? color : `var(--${color})`;
		}
	} else {
		if (property === 'bg' || property === 'border') {
			return color.startsWith('#') ? color : `var(--${color})`;
		} else {
			return `#FFFFFF`;
		}
	}
};

export const getButtonColorOnHover = (color, variant, property) => {
	if (variant === 'outlined') {
		if (property === 'bg') {
			return color.startsWith('#') ? `${color}10` : `var(--${color})`;
		}
		if (property === 'border') {
			return color.startsWith('#') ? color : `var(--${color})`;
		} else {
			return color.startsWith('#') ? color : '#FFFFFF';
		}
	} else {
		if (property === 'bg' || property === 'border') {
			return color.startsWith('#') ? color : `var(--${color}-hover)`;
		} else {
			return `#FFFFFF`;
		}
	}
};
